export default [{ //产能管理
        path: '/capacity',
        component: () =>
            import ('@/components/page/capacity/capacityList'),
        meta: { title: 'capacity.capacityManage' },
    },
    { //产能管理详情
        path: '/capacityDetail',
        component: () =>
            import ('@/components/page/capacity/capacityDetail'),
        meta: { title: 'capacity.capacityDetail' },
    },
    { //产能任务创建
        path: '/addCapacity',
        component: () =>
            import ('@/components/page/capacity/addCapacity'),
        meta: { title: 'capacity.addCapacity' },
    },
    { //产能模板维护
        path: '/capacityListMaintain',
        component: () =>
            import ('@/components/page/capacity/CapacityListMaintain'),
        meta: { title: 'capacity.CapacityMaintain' },
    },

]